import React from "react";
import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import PackageSelectorStyles from "./PackageSelector.styles";
import { IPackageSelectorProps } from "./PackageSelector.types";
import useQuery from "../../../shared/hooks/useQuery";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { isNullOrUndefined } from "../../../shared/utils/data.utils";
import { isMobile } from "react-device-detect";
import PACKAGE_SELECTOR_POPOUT from "./popout-component/PackageSelectorPopOut.component";
import { useSelector } from "react-redux";
import { RootState } from "../../../state-management/root-reducer";
import { setSelectedPackage } from "../../../state-management/slices/packageSelector/package-selector.slice";
import { ProjectPackageSummaryVM } from "../../../api/generated/models";
import { useAppDispatch } from "../../../state-management/store";
import PACKAGE_LIST from "./list-component/PackageList.component";

const PACKAGE_SELECTOR: React.FC<IPackageSelectorProps> = (
  props: IPackageSelectorProps
) => {
  const { subscription } = props;
  const { data, isError, isLoading } = subscription;

  const query = useQuery();
  const history = useHistory();
  const dispatch = useAppDispatch();
  const packageId = query.get("packageId");

  // APP STATE
  const { selectedPackage } = useSelector(
    (state: RootState) => state.packageSelector
  );

  useEffect(() => {
    if (data && data.packages && data.packages.length && !selectedPackage) {
      let packageToSelect: ProjectPackageSummaryVM | undefined;

      // istanbul ignore next
      if (packageId) {
        packageToSelect = data.packages.find((currentPackage): boolean => {
          return currentPackage.packageId === packageId;
        });
      } else {
        packageToSelect = data.packages[0];
      }

      // istanbul ignore next
      if (packageToSelect) {
        dispatch(setSelectedPackage(packageToSelect));
      }
    }
  }, [data, dispatch, history, packageId, selectedPackage]);

  return (
    <PackageSelectorStyles.PackageSelector
      className="package-selector"
      data-testid="package-selector-component"
    >
      <PackageSelectorStyles.PackageSelectorHeader
        className="package-selector-header"
        data-testid="package-selector-header"
      >
        <h4>Packages</h4>
        <p>
          Packages are groups of work that are scheduled to happen at the same
          time.
        </p>
      </PackageSelectorStyles.PackageSelectorHeader>
      <PackageSelectorStyles.PackageSelectorBody
        className="package-selector-body"
        data-testid="package-selector-body"
      >
        {isLoading && !isError && (
          <div
            className="spinner-container"
            data-testid="package-selector-loading-spinner"
          >
            <FontAwesomeIcon
              icon={faSpinner}
              className="fa-spin"
              size="3x"
              color="#666666"
            />
          </div>
        )}

        {/* IF DESKTOP: show package selector list */}
        {!isMobile &&
          !isLoading &&
          !isError &&
          !isNullOrUndefined(data) &&
          !isNullOrUndefined(data.packages) && (
            <PACKAGE_LIST packageList={data.packages} />
          )}

        {/* OTHERWISE, IF MOBILE: show package selector popout component */}
        {isMobile &&
          !isLoading &&
          !isError &&
          !isNullOrUndefined(data) &&
          !isNullOrUndefined(data.packages) && (
            <div className="popout-container">
              <span className="package-list-label">
                Showing 1 of {data?.totalPackages} package(s)
              </span>
              <PACKAGE_SELECTOR_POPOUT />
            </div>
          )}
      </PackageSelectorStyles.PackageSelectorBody>
    </PackageSelectorStyles.PackageSelector>
  );
};

export default PACKAGE_SELECTOR;
